import React, {Component} from "react";
import { Link } from "react-router-dom";

class Header extends Component{
    render(){
        return(
            <header id="top">
            <Link to="/"><h1>edsite.black</h1></Link>
            <nav id="navigation">
                <Link to="/">HOME</Link>
                <a href="https://ia-ia-ia.world/">COMICS</a>
                <Link to="/reviews">REVIEWS</Link>
                <Link to="/bingo">INOUE BINGO</Link>
                <Link to="takahashi-bingo">TAKAHASHI BINGO</Link>
                <Link to="/dnd">GRADIA UPDATE</Link>
                <Link to="/links">OTHER SITES</Link>
            </nav>
            </header>
        );
    }
}

export default Header;